export function calculateSelectedRowsHeight(
  selectedIds: string[],
  rowRefs: Map<string, HTMLElement | null>
): number {
  let totalHeight = 0;
  selectedIds.forEach((id) => {
    const el = rowRefs.get(id);
    if (el) {
      totalHeight += el.offsetHeight;
    }
  });
  return totalHeight;
}
